import React, { FunctionComponent, ReactElement } from 'react'
import { DropDownTextStyle } from '../../DropDownTypes'
import { GridProps } from '../../../../styles/types'
import Touchable from '../../../Touchable'
import Grid from '../../../Grid'
import Text from '../../../Text'

type DropDownLabelProps = {
    label: string
    onPress: () => void
    dropDownContainerStyle?: GridProps
    dropDownTextStyle?: DropDownTextStyle
    renderDropDownIcon: () => ReactElement | null
    testID?: string
}

const DropDownLabel: FunctionComponent<DropDownLabelProps> = ({
    label,
    onPress,
    dropDownContainerStyle,
    dropDownTextStyle,
    renderDropDownIcon,
    testID,
}): ReactElement => {
    return (
        <Touchable activeOpacity={1} onPress={onPress}>
            <Grid noExpand horizontal {...dropDownContainerStyle} testID={testID}>
                <Grid marginRight={2} minWidth={0}>
                    <Text {...dropDownTextStyle}>{label}</Text>
                </Grid>
                {renderDropDownIcon()}
            </Grid>
        </Touchable>
    )
}

export default DropDownLabel
